import { useCallback, useEffect, useState } from 'react';
import {
  GetAllVendorServiceCategories,
  GetVendorOfferAgreements,
} from '../../../../../../Services';
import { VendorsTranslationPath } from '../../../I18n/VendorsLocale';
import { showError } from '../../../../../../Helper';
import { useTranslation } from 'react-i18next';

export const useFetchVendorCategories = (id) => {
  const { t } = useTranslation(VendorsTranslationPath);
  const [categories, setCategories] = useState([]);
  const [associatedAgreements, setAssociatedAgreements] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [vendorId, setVendorId] = useState(id);

  const getAllVendorServiceCategories = useCallback(async () => {
    try {
      setIsLoading(true);
      const { result } = await GetAllVendorServiceCategories({
        pageIndex: 1,
        pageSize: 100,
        vendorId,
      });
      setCategories(result);
    } catch (error) {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  }, [vendorId]);

  const getAllVendorAssociatedAgreements = useCallback(async () => {
    try {
      setIsLoading(true);
      const result = await GetVendorOfferAgreements(vendorId);
      setAssociatedAgreements(result);
    } catch (error) {
      showError(t('something_went_wrong_while_fetching_vendor_agreements'));
    } finally {
      setIsLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    if (!!vendorId) {
      getAllVendorServiceCategories();
      getAllVendorAssociatedAgreements();
    }
  }, [getAllVendorServiceCategories, getAllVendorAssociatedAgreements]);

  useEffect(() => {
    if (id) {
      setVendorId(id);
    }
  }, [id]);
  return {
    categories,
    associatedAgreements,
    isLoading,
    setVendorId,
  };
};
